module.exports = __webpack_public_path__ + "static/scale-model-of-plains-art-museum-in-fargo-north-dakota-2e6b7a6606af27e18777efd04793e25e.png";